class ProjectDetails {
    constructor(name, description) {
        this.name = name;
        this.description = description;
    }
}

export default ProjectDetails;
